import axios from 'axios'

export default {
    findAll() {
        return axios.get('/api/module')
    },
    saveModulVerantwortliche(modulId, modulVerantwortliche) {
        return axios.put('/api/module/change_modulverantwortliche', {
            modul: `/api/module/${modulId}`,
            modulverantwortliche: modulVerantwortliche
        })
    },
    saveLehrende(modulId, lehrendeIds) {
        return axios.put('/api/module/change_lehrende', {
            modul: `/api/module/${modulId}`,
            lehrende: lehrendeIds
        })
    }
}
